import { apiClient } from '../utils';
import { store } from '../redux/store';
import { showAlert } from '../redux/modules/alert';
import { actions as ipgMineActions } from '../redux/modules/ipgMine';
import { handleError } from './';

type Payload = {
  email: String,
  firstName: String,
  lastName: String,
  nationalCode: String,
  birthday: String,
  iban: String,
  address: String,
  postalCode: String,
  phoneNumber: String,
};

export const activateIpg = async ({
  email,
  firstName,
  lastName,
  nationalCode,
  birthday,
  iban,
  address,
  postalCode,
  phoneNumber,
}: Payload) => {
  const data = {
    ...(email ? { email } : {}),
    ...(firstName ? { firstName } : {}),
    ...(lastName ? { lastName } : {}),
    ...(nationalCode ? { nationalCode } : {}),
    ...(birthday ? { birthday } : {}),
    ...(iban ? { iban } : {}),
    ...(address ? { address } : {}),
    ...(postalCode ? { postalCode } : {}),
    ...(phoneNumber ? { phoneNumber } : {}),
  };

  return apiClient
    .post('/shop/ipg/activate', { data })
    .then((result) => {
      store.dispatch(showAlert('درخواست شما با موفقیت ثبت شد.', 'success'));
      store.dispatch(ipgMineActions.resetCache());
      return result;
    })
    .catch((err) => {
      handleError(err);
      throw err;
    });
};
